import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Linkedin, Twitter } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-400 py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <div className="text-white mb-4">
              <span className="text-xl font-bold">Perspectiva Data</span>
            </div>
            <p className="text-sm">
              Convertimos inversiones en datos en resultados de negocio tangibles para empresas mexicanas.
            </p>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Servicios</h4>
            <ul className="space-y-2">
              <li><Link to="/servicios" className="hover:text-white transition-colors">Evaluación Estratégica</Link></li>
              <li><Link to="/servicios" className="hover:text-white transition-colors">Alineación con Negocio</Link></li>
              <li><Link to="/servicios" className="hover:text-white transition-colors">Implementación Escalable</Link></li>
              <li><Link to="/servicios" className="hover:text-white transition-colors">Diseño de Equipos</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Recursos</h4>
            <ul className="space-y-2">
              <li><Link to="/recursos" className="hover:text-white transition-colors">Blog</Link></li>
              <li><Link to="/recursos" className="hover:text-white transition-colors">Podcast</Link></li>
              <li><Link to="/recursos" className="hover:text-white transition-colors">Guías</Link></li>
              <li><Link to="/recursos" className="hover:text-white transition-colors">Newsletter</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Contacto</h4>
            <ul className="space-y-2">
              <li className="flex items-center">
                <Mail className="mr-2 h-4 w-4" />
                <a href="mailto:contacto@perspectivadata.mx" className="hover:text-white transition-colors">contacto@perspectivadata.mx</a>
              </li>
              <li><span className="text-gray-400">CDMX, México</span></li>
              <li className="flex space-x-4 mt-4">
                <a href="https://linkedin.com/in/your-profile" className="hover:text-white transition-colors flex items-center">
                  <Linkedin className="mr-1 h-4 w-4" /> LinkedIn
                </a>
                <a href="https://twitter.com/your-profile" className="hover:text-white transition-colors flex items-center">
                  <Twitter className="mr-1 h-4 w-4" /> Twitter
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-12 pt-8 text-sm text-center">
          <p>&copy; 2025 Perspectiva Data. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;